function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import gettext from 'js-utils/gettext';
import PropTypes from 'prop-types';
import Button from '../../button/Button';

var ActionWrapper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ActionWrapper, _PureComponent);

  function ActionWrapper() {
    _classCallCheck(this, ActionWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActionWrapper).apply(this, arguments));
  }

  _createClass(ActionWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          linkUrl = _this$props.linkUrl,
          children = _this$props.children,
          hasNoTabIndex = _this$props.hasNoTabIndex,
          isTargetBlank = _this$props.isTargetBlank,
          isNoFollow = _this$props.isNoFollow,
          linkAlt = _this$props.linkAlt;
      var tabIndex = hasNoTabIndex ? '-1' : '0';
      var aProps = {
        onClick: onClick,
        tabIndex: tabIndex,
        href: linkUrl,
        className: 'eds-media-card-content__action-link',
        'aria-label': gettext('See more of %(linkAlt)s', {
          linkAlt: linkAlt
        })
      };

      if (isTargetBlank) {
        aProps = _objectSpread({}, aProps, {
          target: '_blank',
          rel: 'noopener noreferrer'
        });
      }

      if (isNoFollow) {
        var prevRelProps = aProps.rel || '';
        aProps = _objectSpread({}, aProps, {
          rel: "".concat(prevRelProps, " nofollow").trim()
        });
      }

      var component = children;

      if (linkUrl) {
        component = React.createElement("a", aProps, children);
      } else if (onClick) {
        var buttonProps = {
          onClick: onClick,
          tabIndex: tabIndex,
          style: 'none',
          size: 'block'
        };
        component = React.createElement(Button, buttonProps, children);
      }

      return component;
    }
  }]);

  return ActionWrapper;
}(PureComponent);

_defineProperty(ActionWrapper, "propTypes", {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  linkUrl: PropTypes.string,
  linkAlt: PropTypes.string,
  hasNoTabIndex: PropTypes.bool,
  isTargetBlank: PropTypes.bool,
  isNoFollow: PropTypes.bool
});

export { ActionWrapper as default };